export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/BellIcon.b50c5cd0.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};